import { render, staticRenderFns } from "./OffersPause.vue?vue&type=template&id=323a051c&scoped=true"
import script from "./OffersPause.vue?vue&type=script&lang=js"
export * from "./OffersPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a051c",
  null
  
)

export default component.exports